// thumb-carousel.js
// Simple thumbnail scroll with arrow reinsertion and minimal opacity logic
(function() {
  const STEP = 190;

  function createArrow(id) {
    const a = document.createElement('a');
    a.id = id;
    a.href = '#';
    const span = document.createElement('span');
    a.appendChild(span);
    return a;
  }

  function initCarousel() {
    const nav = document.querySelector('.product-gallery.starapps .product-gallery--navigation');
    if (!nav) return;

    // Ensure left arrow is present
    let leftArrow = nav.querySelector('#thumb-left-arrow');
    if (!leftArrow) {
      leftArrow = createArrow('thumb-left-arrow');
      nav.insertBefore(leftArrow, nav.firstChild);
    }

    // Ensure right arrow is present
    let rightArrow = nav.querySelector('#thumb-right-arrow');
    if (!rightArrow) {
      rightArrow = createArrow('thumb-right-arrow');
      nav.appendChild(rightArrow);
    }

    // Create or reuse thumbnail container
    let container = nav.querySelector('#media-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'media-container';
      nav.insertBefore(container, rightArrow);
    }

    // Move thumbnails into container
    nav.querySelectorAll('.product-gallery--media-thumbnail').forEach(el => {
      if (el.parentNode !== container) {
        container.appendChild(el);
      }
    });

    // Function to update arrow opacity
    function checkArrows() {
      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      leftArrow.style.opacity = container.scrollLeft <= 0 ? '0.4' : '1';
      rightArrow.style.opacity = container.scrollLeft >= maxScrollLeft ? '0.4' : '1';
    }

    // Attach click handlers for arrows once
    [
      { element: leftArrow, offset: -STEP },
      { element: rightArrow, offset: STEP }
    ].forEach(({ element, offset }) => {
      if (!element.dataset.thumbCarouselInit) {
        element.addEventListener('click', e => {
          e.preventDefault();
          container.scrollBy({ left: offset, behavior: 'smooth' });
        });
        element.dataset.thumbCarouselInit = 'true';
      }
    });

    // Listen to container scroll and perform initial check
    container.addEventListener('scroll', checkArrows);
    checkArrows();
  }

  document.addEventListener('DOMContentLoaded', initCarousel);
  new MutationObserver(initCarousel).observe(document.body, { childList: true, subtree: true });
})();
